<template>
	<div>

		<v-layout row>
			<v-flex row wrap>
				<v-select style="padding-left: 10px; padding-right: 10px; max-width: 500px"
					v-if="!readonly || data.selected.length > 0"
					:disabled="readonly"
					v-model="data.selected"
					:items="options"
					item-text="name"
					item-value="id"
					label="Grupy docelowe"
					aria-label="beneficiaries"
					for="choose-beneficiaries-show-group-target"
					id="choose-beneficiaries-show-group-target"
					multiple
					@input="sync"
				></v-select>

				<egranty-switch
					v-if="data.otherBeneficiaryEnabled || !readonly"
					class="no-print"
					:disabled="readonly"
					title='Inna grupa docelowa'
					v-model="data.otherBeneficiaryEnabled"
					@input="sync"
					aria-label="another beneficiary enabled"
					style="margin-right: 10px;"
				></egranty-switch>
			</v-flex>
		</v-layout>
		<v-expand-transition>
			<v-layout v-show="data.otherBeneficiaryEnabled">
				<v-flex>
					<egranty-text-input-field class="choose-beneficiaries-another-name-group"
						:disabled="readonly"
						label="Nazwa innej grupy docelowej"
						for="choose-beneficiaries-other-group-name"
						id="choose-beneficiaries-other-group-name"
						v-model="data.otherBeneficiary"
						:max-length="255"
						@input="sync"
						textarea
					>
					</egranty-text-input-field>
				</v-flex>
			</v-layout>
		</v-expand-transition>

	</div>
</template>

<script>
	import {Beneficiary} from "@/api/generated/Beneficiary";
	import EgrantySwitch from "../../../../genericComponents/EgrantySwitch";
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
	import {createLabels} from "@/utils/createLabels";

	export default {
		name: "ProjectChooseBeneficiaries",
		components: {EgrantyTextInputField, EgrantySwitch},
		methods: {
			getContestId() {
				return this.contestId;
			},

			sync() {
				if (!this.data.otherBeneficiaryEnabled) {
					this.data.otherBeneficiary = null;
				}
				this.$emit("input", this.data);
			},

		},

		mounted() {
			Beneficiary.getAllBeneficiaries(
				this,
				this.getContestId(),
				response => {
					this.options = response;
				},
			);

		},

		updated () {
			createLabels.addAriaLabelForInputWithRole("checkbox");
		},


		data() {
			return {
				data: {
					contestId: null,
					selected: [],
					otherBeneficiary: "",
					otherBeneficiaryEnabled: false,
				},
				options: [],

			};
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val === undefined) {
						return;
					}
					this.data.otherBeneficiary = val.otherBeneficiary;
					this.data.otherBeneficiaryEnabled = val.otherBeneficiaryEnabled;
					if (this.data.otherBeneficiaryEnabled === undefined) {
						this.data.otherBeneficiaryEnabled = (val.otherBeneficiary !== null && val.otherBeneficiary !== undefined && val.otherBeneficiary !== '');
					}
					this.data.selected = val.selected;
				},
			},
		},

		props: {
			value: {},
			readonly: {
				default: false
			},
			contestId: null,
		},
	};
</script>

<style scoped>
	.choose-beneficiaries-section-divider {
		background-color: #0075E2 !important;

	}

	.choose-beneficiaries-another-name-group {
		padding-left: 20px;
		padding-right: 20px;
	}

</style>
